<template>
<div class="introduce" v-if="versionInfo">
  <div class="introduce-title">{{ title }}</div>
  <div class="introduce-type">
    <span class="label" v-if="versionInfo.network!==2">
      <img v-if="versionInfo.network===1" src="../../../public/image/jurisdiction/wl1.png">
      <img v-else src="../../../public/image/jurisdiction/wl0.png">
      {{ versionInfo.network===1? '需要网络':'无需网络' }}
    </span>
    <span class="label" v-if="versionInfo.vpn!==2">
      <img v-if="versionInfo.vpn===1" src="../../../public/image/jurisdiction/jsq1.png">
      <img v-else src="../../../public/image/jurisdiction/jsq0.png">
      {{ versionInfo.vpn===1? '需要加速器':'无需加速器' }}
    </span>
    <span class="label" v-if="versionInfo.googleFrame!==2">
      <img v-if="versionInfo.googleFrame===1" src="../../../public/image/jurisdiction/gg1.png">
      <img v-else src="../../../public/image/jurisdiction/gg0.png">
      {{ versionInfo.googleFrame===1? '需要谷歌套件':'无需谷歌套件' }}
    </span>
    <span class="label" v-if="versionInfo.shopping!==2">
      <img v-if="versionInfo.shopping===1" src="../../../public/image/jurisdiction/ng1.png">
      <img v-else src="../../../public/image/jurisdiction/ng0.png">
      {{ versionInfo.shopping===1? '有内购':'无内购' }}
    </span>
    <span class="label" v-if="versionInfo.ad!==2">
      <img v-if="versionInfo.ad===1" src="../../../public/image/jurisdiction/ggao1.png">
      <img v-else src="../../../public/image/jurisdiction/ggao0.png">
      {{ versionInfo.ad===1? '有广告':'无广告' }}
    </span>
  </div>
  <div class="introduce-content" v-if="editorRecommend!==''">{{ editorRecommend }}</div>
  <div class="introduce-content-instrument" v-if="editorRecommendList">
    <div v-for="(item,index) in editorRecommendList" :key="index">{{ item }}</div>
  </div>
  <div class="introduce-operation" v-if="packTxt!=='hide'">
    <span class="introduce-operation-pack" @click="openOfficial">{{ packTxt }}&nbsp;<i class="fa fa-chevron-down" aria-hidden="true"></i></span>
  </div>
</div>
</template>

<script>
export default {
  name: 'Introduce',
  props: {
    title: {
      type: String,
      default: '工具介绍'
    },
    packTxt: {
      type: String,
      default: '更多'
    },
    versionInfo: {
      type: Object
    },
    editorRecommend: {
      type: String,
      default: ''
    },
    editorRecommendList: {
      type: Array
    }
  },
  methods: {
    openOfficial () {
      this.$parent.openOfficial()
    }
  }
}
</script>

<style scoped lang="scss">
.introduce{
  .introduce-title{
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #F5F5F5;
    padding-bottom: 14px;
  }
  .introduce-type{
    display: flex;
    flex-wrap: wrap;
    .label{
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4C5C6D;
      margin-right: 30px;
      margin-bottom: 5px;
      >img{
        width: 14px;
        height: 14px;
      }
    }
  }
  .introduce-content{
    margin-top: 13px;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #68829E;
    line-height: 27px;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .introduce-content-instrument{
    margin-top: 13px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #68829E;
    line-height: 27px;
  }
  .introduce-operation{
    margin-top: 22px;
    display: flex;
    justify-content: center;
    .introduce-operation-pack{
     padding: 5px 11px;
      background: #202632;
      border-radius: 11px;

      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #2992FF;
    }
  }
}
</style>
